import { IconArrowBigRight, IconPoints, Text } from "@idg-web-platform/pulse";
import { formatPointAmount } from "../../utils/formats.ts";
import css from "./pointBalanceCard.module.css";
import classNames from "classnames";

export interface PointBalanceCardProps {
  pointBalance: number;
  exchangeRate: number;
  linkTo?: string;
  class?: string;
}

export function PointBalanceCard({
  pointBalance,
  exchangeRate,
  linkTo,
  class: className,
}: PointBalanceCardProps) {
  const value = pointBalance * exchangeRate;

  const content = (
    <>
      <Text fontStyle={"bold"} sizeStep={0} removeMargin={true} class={css.title}>
        Aktueller Punktestand
      </Text>
      <div className={css.pointsRow}>
        <span data-dd-privacy="mask" className={css.pointsValue} data-testid={"point-balance"}>
          {pointBalance}
        </span>
        <div className={css.icon}>
          <IconPoints fluid={true} />
        </div>
        <span className={css.punkteText}>Punkte</span>
      </div>
      <Text sizeStep={0} removeMargin={true}>
        entspricht <span data-dd-privacy="mask">{formatPointAmount(value)}</span>, die du beim
        nächsten Kauf einlösen kannst.
      </Text>
    </>
  );

  if (linkTo) {
    return (
      <a href={linkTo} className={classNames(css.card, css.cardLink, className)}>
        {content}
        <span className={css.linkText}>
          PUNKTEKONTO ANZEIGEN <IconArrowBigRight />
        </span>
      </a>
    );
  }

  return <div className={classNames(css.card, className)}>{content}</div>;
}
